export const EDIT_DATA = "EDIT_DATA";
export const ADD_DATA_ORGANIZATION = "ADD_DATA_ORGANIZATION";
export const ADD_FULL_DATA_ORGANIZATION = "ADD_FULL_DATA_ORGANIZATION";